export const cssFontValues = {
  'Arial': {
    fontFamily: 'Arial, Helvetica, sans-serif',
  },
  'Arial Black': {
    fontFamily: '"Arial Black", Gadget, sans-serif',
  },
  'Arial Italic': {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontStyle: 'italic',
  },
  'Arial Narrow': {
    fontFamily: '"Arial Narrow", sans-serif',
  },
  'Arial Rounded MT Bold': {
    fontFamily: '"Arial Rounded MT Bold", sans-serif',
  },
  'Baskerville Old Face': {
    fontFamily: '"Baskerville Old Face", "Book Antiqua", Palatino, serif',
  },
  'Bookman Old Style': {
    fontFamily: '"Bookman Old Style", serif',
  },
  'Bookshelf Symbol 7': {
    fontFamily: '"Bookshelf Symbol 7", sans-serif',
  },
  'Brush Script MT': {
    fontFamily: '"Brush Script MT", cursive',
  },
  'Calibri': {
    fontFamily: 'Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  },
  'Calibri Light': {
    fontFamily: 'Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  },
  'Cambria': {
    fontFamily: 'Cambria, Georgia, serif',
  },
  'Cambria Math': {
    fontFamily: '"Cambria Math", serif',
  },
  'Century': {
    fontFamily: 'Century, sans-serif',
  },
  'Century Schoolbook': {
    fontFamily: '"Century Schoolbook", serif',
  },
  'Comic Sans MS': {
    fontFamily: '"Comic Sans MS", cursive, sans-serif',
  },
  'Consolas': {
    fontFamily: 'Consolas, monaco, monospace',
  },
  'Consolas Italic': {
    fontFamily: 'Consolas, monaco, monospace',
    fontStyle: 'italic',
  },
  'Cooper Black': {
    fontFamily: '"Cooper Black", sans-serif',
  },
  'Copperplate Gothic Light': {
    fontFamily: '"Copperplate Gothic Light", sans-serif',
  },
  'Courier': {
    fontFamily: 'Courier, monospace',
  },
  'Courier New': {
    fontFamily: '"Courier New", Courier, monospace',
  },
  'Garamond': {
    fontFamily: 'Garamond, serif',
  },
  'Georgia': {
    fontFamily: 'Georgia, serif',
  },
  'Gill Sans MT': {
    fontFamily: '"Gill Sans MT", sans-serif',
  },
  'Gill Sans MT Condensed': {
    fontFamily: '"Gill Sans MT Condensed", sans-serif',
  },
  'Helvetica': {
    fontFamily: 'Helvetica, Arial, sans-serif',
  },
  'Lucida Console': {
    fontFamily: '"Lucida Console", Monaco, monospace',
  },
  'MS Outlook': {
    fontFamily: '"MS Outlook", sans-serif',
  },
  'Malgun Gothic': {
    fontFamily: '"Malgun Gothic", sans-serif',
  },
  'Meiryo': {
    fontFamily: 'Meiryo, sans-serif',
  },
  'monospace': {
    fontFamily: 'monospace',
  },
  'Myriad Pro': {
    fontFamily: '"Myriad Pro", Myriad, sans-serif',
  },
  'sans-serif': {
    fontFamily: 'sans-serif',
  },
  'serif': {
    fontFamily: 'serif',
  },
  'Symbol': {
    fontFamily: 'Symbol, sans-serif',
  },
  'SimSun': {
    fontFamily: '"SimSun", sans-serif',
  },
  'Tahoma': {
    fontFamily: 'Tahoma, Geneva, sans-serif',
  },
  'Times New Roman': {
    fontFamily: '"Times New Roman", Times, serif',
  },
  'Trebuchet MS': {
    fontFamily: '"Trebuchet MS", Helvetica, sans-serif',
  },
  'Verdana': {
    fontFamily: 'Verdana, Geneva, sans-serif',
  },
};